/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Box } from 'sarsaparilla';
import { LayoutControlContext } from './DetailedAvailabilityPageLayout';

function DetailedAvailabilityGridAndActions({ children }) {
    const { isFullView, isMobileApp, isShowAvailabilityFilters } =
        useContext(LayoutControlContext);

    if (isShowAvailabilityFilters && isMobileApp) {
        return null;
    }

    return (
        <Box>
            {React.Children.map(children, (child) => {
                if (React.isValidElement(child)) {
                    // All this because AvailabilityGrid needs this prop
                    return React.cloneElement(child, { isFullView });
                }
                return child;
            })}
        </Box>
    );
}

DetailedAvailabilityGridAndActions.propTypes = {
    children: PropTypes.node,
};

export default DetailedAvailabilityGridAndActions;
